import React, { useState } from "react";

const CatalogContext = React.createContext();

const CatalogContextProvider = (props) => {
    const [sortObj, setSortObj] = useState(null);
    const [sortSecond, setSortSecond] = useState(null);
    const [firstLevel, setFirstLevel] = useState(null);
    const [secondLevel, setSecondLevel] = useState(null);
    const [value, setValue] = useState(null);
    const [valueSecond, setValueSecond] = useState(null);

    const contextValue = {
      sortObj,
      setSortObj,
      sortSecond,
      setSortSecond,
      firstLevel,
      setFirstLevel,
      secondLevel,
      setSecondLevel,
      value,
      setValue,
      valueSecond,
      setValueSecond,
    }

      return (
          <CatalogContext.Provider
            value={contextValue}
          >
              {props.children}
          </CatalogContext.Provider>
      );
  }
  
  export { CatalogContext, CatalogContextProvider };
  